module.exports = __webpack_public_path__ + "img/scene_pastel_colors_big@2x.3b414d16.png";